if(!customElements.get('media-with-text')){
    class MediaWithText extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.videos = this.querySelectorAll('video');

            this.videos.forEach(video => {
                if(typeof video === 'undefined') return;
                video.addEventListener("loadeddata", e => {
                    video.classList.add('loaded');
                });

                if(video.readyState >= 2){
                    video.classList.add('loaded');
                }
            });
        }
    }

    customElements.define('media-with-text', MediaWithText);
}